import cn from 'classnames'
import { Box } from 'components/Material/index'
import { MainContainer } from 'components/Custom'
import { TopAppBar, TopAppBarProps } from '../TopAppBar'
import useSidebarStore from 'store/useSidebar'
import { useIsMobile } from 'hooks/useIsResponsive'
import { useEffect } from 'react'
import ErrorPageComponent from '../ErrorPageComponent'
import LoadingPage from '../LoadingPage'

interface ContainerProps extends TopAppBarProps {
  children: React.ReactNode
  containerClassName?: string
  bgColor?: 'white' | 'dark'
  isErrorPage?: boolean
  isPageLoading?: boolean
  activeSidebar?: JSX.Element
  refetchPage?: () => void
  showButton?: boolean
  imagePage?: JSX.Element
}

export const Container = ({
  children,
  containerClassName,
  bgColor = 'white',
  isErrorPage = false,
  isPageLoading = false,
  activeSidebar,
  refetchPage,
  showButton = true,
  imagePage,
  ...propsTopAppBar
}: ContainerProps) => {
  const { isOpen, closeSidebar } = useSidebarStore((state) => state)
  const isMobile = useIsMobile()

  useEffect(() => {
    closeSidebar()
  }, [])

  const containerStyles = {
    'flex w-full h-[calc(100vh-64px)] bottom-0': !isMobile || (isMobile && !isOpen),
    'flex w-full h-screen': isMobile && isOpen,
    'bg-black': bgColor === 'dark',
    'bg-gray-10': bgColor === 'white',
    'fixed overflow-hidden ': true
  }

  return (
    <>
      {!imagePage && (!isMobile || (isMobile && !isOpen)) && (
        <TopAppBar {...propsTopAppBar} isSidebarOpen={isOpen} />
      )}
      <Box className={cn(containerStyles, containerClassName)}>
        <MainContainer
          bgColor={bgColor}
          isSidebarOpen={isOpen && !!activeSidebar && !isErrorPage}
          showButton={showButton}
        >
          {isErrorPage ? (
            <ErrorPageComponent refetchpage={refetchPage} />
          ) : isPageLoading ? (
            <LoadingPage />
          ) : (
            children
          )}
        </MainContainer>
        {isOpen && !isErrorPage && !!activeSidebar && activeSidebar}
      </Box>
      {imagePage && imagePage}
    </>
  )
}

export default Container
